import { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { HashLink as Link } from "react-router-hash-link";
import { FaBars } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import { FaSun, FaMoon } from "react-icons/fa";
import "../styles/NavBar.css";

export default function NavBar() {
  const [mobile, setMobile] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [theme, setTheme] = useState("dark");
  const location = useLocation();

  useEffect(() => {
    // Get theme from localStorage or default to dark
    const savedTheme = localStorage.getItem("theme") || "dark";
    setTheme(savedTheme);
    document.documentElement.setAttribute("data-theme", savedTheme);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      setScrolled(isScrolled);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobile(false);
  }, [location]);

  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
    document.documentElement.setAttribute("data-theme", newTheme);
  };

  return (
    <nav className={`navbar-container ${scrolled ? "scrolled" : ""}`}>
      <div className="navbar-content">
        <Link to="/">
          <p className="brand">{`<greatdaveo />`}</p>
        </Link>

        <div className="desktop-nav">
          <NavLink to="/" end>
            Home
          </NavLink>
          <NavLink to="/projects">Projects</NavLink>
          <NavLink to="/blog">Blog</NavLink>
          {/* <NavLink to="/youtube">YouTube</NavLink> */}
          <Link to="/contact">Contact</Link>
          <button
            className="theme-toggle"
            onClick={toggleTheme}
            aria-label={`Switch to ${
              theme === "light" ? "dark" : "light"
            } mode`}
          >
            {theme === "light" ? <FaMoon /> : <FaSun />}
          </button>
        </div>

        <div className="mobile-menu-icon" onClick={() => setMobile(!mobile)}>
          {mobile ? <ImCross /> : <FaBars />}
        </div>
      </div>

      <div className={`mobile-nav ${mobile ? "open" : ""}`}>
        <NavLink to="/" end onClick={() => setMobile(false)}>
          Home
        </NavLink>
        <NavLink to="/projects" onClick={() => setMobile(false)}>
          Projects
        </NavLink>
        <NavLink to="/blog" onClick={() => setMobile(false)}>
          Blog
        </NavLink>
        <NavLink to="/youtube" onClick={() => setMobile(false)}>
          YouTube
        </NavLink>
        <Link to="/contact" onClick={() => setMobile(false)}>
          Contact
        </Link>
        <button
          className="theme-toggle"
          onClick={toggleTheme}
          aria-label={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
        >
          {theme === "light" ? <FaMoon /> : <FaSun />}
        </button>
      </div>
    </nav>
  );
}
